/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

import { ResumeSubSection } from '../sub-section/sub-section.model';

/**
 * Model class for the Experience resume section.
 */
export class ResumeExperienceSubSection extends ResumeSubSection {
  /**
   * Achievements for the work experience section.
   */
  achievements : string;

  /**
   * Company for the work experience section.
   */
  company : string;

  /**
   * Currently Working for the work experience section.
   */
  current : boolean = false;

  /**
   * Flag that indicate whether entry is open for edit mode.
   */
  public editMode: boolean = false;

  /**
   * End date for the work experience section.
   */
  endDate : Date;

  /**
   * End date placeholder for the work experience section.
   */
  endDatePlaceholder : string;

  /**
   * Job location for the work experience section.
   */
  location : string;

  /**
   * Responsibilities for the work experience section.
   */
  responsibilities : string;

  /**
   * Start date for the work experience section.
   */
  startDate : Date;

  /**
   * Strength for the work experience section.
   */
  strengths : string;

  /**
   * Job title for the work experience section.
   */
  title : string;

  /**
   * Work experience summary.
   */
  summary: string = ' ';

  /**
   * logo url
   */
  public logoUrl: string;

  /**
   * logo image asset
   */
  public logo;

  /**
   * Work highlights
   */
  workHighlights: Array<string>;

  /**
   * Default Constructor.
   */
  constructor(init?: Partial<ResumeExperienceSubSection>) {
    super(init);
    Object.assign(this, init);
    this.workHighlights = [];
  }
}
